"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSResults = void 0;
var React = require("react");
var context_1 = require("../context");
/** [[include:components/results.md]] */
var SSResults = /** @class */ (function (_super) {
    __extends(SSResults, _super);
    function SSResults() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @hidden */
        _this.state = {
            pagination: {
                page: null,
                limit: null,
            },
        };
        return _this;
    }
    /** @hidden */
    SSResults.prototype.componentDidMount = function () {
        this.setPagination();
    };
    /** @hidden */
    SSResults.prototype.componentDidUpdate = function () {
        this.setPagination();
    };
    /** @hidden */
    SSResults.prototype.setPagination = function () {
        var _this = this;
        if (!this.props.pagination) {
            return;
        }
        /** Get Paginiation to be compared against Component State */
        var pagination = {
            page: this.context.searchspring.ready ? this.state.pagination.page : typeof this.context.searchspring.query.results.page === "number" ? this.context.searchspring.query.results.page : this.props.pagination.page,
            limit: this.context.searchspring.ready ? this.state.pagination.limit : typeof this.context.searchspring.query.results.limit === "number" ? this.context.searchspring.query.results.limit : this.props.pagination.limit,
        };
        var pageChanged = this.state.pagination.page !== pagination.page;
        var limitChanged = this.state.pagination.limit !== pagination.limit;
        if (pageChanged || limitChanged) {
            this.setState({
                pagination: pagination,
            }, function () { return _this.context.searchspring.setPagination(pagination.page, pagination.limit); });
        }
    };
    SSResults.prototype.renderFunctionDefault = function (renderTarget) {
        var props = __assign(__assign({}, this.props.props), { results: this.context.searchspring.current.results, loading: this.context.searchspring.loading, empty: !this.context.searchspring.loading && !this.context.searchspring.current.results.length });
        return renderTarget(props);
    };
    SSResults.prototype.renderFunctionSet = function (renderTarget) {
        var _this = this;
        if (this.context.searchspring.loading) {
            if (renderTarget.loading) {
                return renderTarget.loading(this.props.props);
            }
        }
        if (!this.context.searchspring.loading && !this.context.searchspring.current.results.length) {
            if (renderTarget.empty) {
                return renderTarget.empty(this.props.props);
            }
        }
        if (renderTarget.results) {
            var props = __assign(__assign({}, this.props.props), { results: this.context.searchspring.current.results });
            return renderTarget.results(props);
        }
        if (renderTarget.result) {
            return (React.createElement(React.Fragment, null, this.context.searchspring.current.results.map(function (result, index) {
                var props = __assign(__assign({}, _this.props.props), { result: result, index: index });
                return renderTarget.result(props);
            })));
        }
    };
    SSResults.prototype.renderComponentDefault = function (renderTarget) {
        var props = __assign(__assign({}, this.props.props), { results: this.context.searchspring.current.results, loading: this.context.searchspring.loading, empty: !this.context.searchspring.loading && !this.context.searchspring.current.results.length });
        var DefaultComponent = renderTarget;
        return React.createElement(DefaultComponent, __assign({}, props));
    };
    SSResults.prototype.renderComponentSet = function (renderTarget) {
        var _this = this;
        if (!this.context.searchspring.options.infinite && this.context.searchspring.loading) {
            if (renderTarget.loading) {
                var LoadingComponent = renderTarget.loading;
                return React.createElement(LoadingComponent, __assign({}, this.props.props));
            }
        }
        if (this.context.searchspring.loading && !this.context.searchspring.current.results.length) {
            if (renderTarget.empty) {
                var EmptyComponent = renderTarget.empty;
                return React.createElement(EmptyComponent, __assign({}, this.props.props));
            }
        }
        if (renderTarget.results) {
            var props = __assign(__assign({}, this.props.props), { results: this.context.searchspring.current.results });
            var ResultsComponent = renderTarget.results;
            return React.createElement(ResultsComponent, __assign({}, props));
        }
        if (renderTarget.result) {
            var ResultComponent_1 = renderTarget.result;
            return (React.createElement(React.Fragment, null, this.context.searchspring.current.results.map(function (result, index) {
                var props = __assign(__assign({}, _this.props.props), { result: result, index: index });
                return React.createElement(ResultComponent_1, __assign({ key: result.id }, props));
            })));
        }
    };
    /** @hidden */
    SSResults.prototype.render = function () {
        switch (typeof this.props.render) {
            case typeof Function:
                return this.renderFunctionDefault(this.props.render);
            case typeof Object.create({}):
                return this.renderFunctionSet(this.props.render);
        }
        switch (typeof this.props.component) {
            case typeof Function:
                return this.renderComponentDefault(this.props.component);
            case typeof Object.create({}):
                return this.renderComponentSet(this.props.component);
        }
    };
    /** @hidden */
    SSResults.contextType = context_1.Context;
    return SSResults;
}(React.Component));
exports.SSResults = SSResults;
//# sourceMappingURL=results.js.map